/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import useDocumentTitle from "../../utils/useDocumentTitle";

import CancelIcon from "@material-ui/icons/Cancel";

import AuthApi from "../../context/AuthApi";

import { LogsTable } from "./LogsTable";

import styles from "./Logs.module.scss";

import { useTranslation } from "react-i18next";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { Tab, Tabs } from "../../components/Tabs";
import { useCampaign } from "../../context/campaign";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import { getLocalValue } from "../../utils/auth";
import { getQueryVariable } from "../../utils/getQueryParam";

import { formattedDateString, localToUTC } from "../../utils/datetime";
import { LogsFilterBar } from "./LogsFilterBar";
import { loadFilterState } from "./useLogsFilters";

const STORAGE_KEY = "logsCampaign_filterState";

export function LogsCampaign(props) {
  const { t } = useTranslation();
  useDocumentTitle(props.title);
  const history = useHistory();
  const Auth = useContext(AuthApi);
  const { selectedCampaign } = useCampaign();
  const [id, setId] = useState(getQueryVariable("id"));
  const uid = getLocalValue("uid");
  const userRole = getLocalValue("u_coaching_role_db");
  const [filterValues, setFilterValues] = useState(() => ({
    selectedDateRange: {},
    ...loadFilterState(STORAGE_KEY),
    showFilter: true,
  }));
  const {
    showFilter,
    selectedDateRange,
    selectedSubject,
    selectedType,
    selectedNames,
    selectedCoachNames,
    selectedStatus,
    searchKey,
  } = filterValues;
  const [CoachesFilterBy] = useState("All Coaches");
  const [filterParam, setFilterParam] = useState("");
  const [filterObj, setFilterObj] = useState({});

  const campaignTableHeader = [
    {
      name: "session_datetime",
      label: t("logs.sessionStartDate"),
      width: "10%",
    },
    { name: "session_id", label: "Session ID", width: "8%" },
    { name: "duration", label: t("logs.duration"), width: "8%" },
    { name: "type", label: t("logs.type"), width: "8%" },
    { name: "subject", label: t("logs.subjects"), width: "10%" },
    { name: "coach_name", label: t("logs.coach"), width: "10%" },
    { name: "coach_employee_id", label: t("logs.coachID"), width: "8%" },
    { name: "coachee_name", label: t("logs.coachee"), width: "10%" },
    { name: "coachee_employee_id", label: t("logs.coacheeID"), width: "8%" },
    {
      name: "completion_datetime",
      label: t("logs.completionDate"),
      width: "10%",
    },
    { name: "status", label: t("logs.status"), width: "10%" },
  ];

  useEffect(() => {
    if (!showFilter) {
      setFilterParam("");
      return;
    }

    let filterObject = {
      showFilter: showFilter,
      selectedDateRange: selectedDateRange,
    };
    let param = `&session_start_date=${formattedDateString(
      localToUTC(selectedDateRange.startDate)
    )}`;
    param += `&session_end_date=${formattedDateString(
      localToUTC(selectedDateRange.endDate)
    )}`;
    if (selectedType) {
      param += `&type=${selectedType.type}`;
      filterObject.selectedType = selectedType;
    }
    if (selectedSubject) {
      param += `&subject=${selectedSubject.id}&subjectable_type=${selectedSubject.subjectable_type}`;
      filterObject.selectedSubject = selectedSubject;
    }

    if (selectedNames) {
      param += `&coachee=${selectedNames.uid}`;
      filterObject.selectedNames = selectedNames;
    }
    if (selectedCoachNames) {
      param += `&coach_id=${selectedCoachNames.uid}`;
      filterObject.selectedCoachNames = selectedCoachNames;
    }
    if (selectedStatus) {
      param += `&status=${selectedStatus.value}`;
      filterObject.selectedStatus = selectedStatus;
    }

    setFilterParam(param);
    setFilterObj(filterObject);
  }, [
    showFilter,
    selectedSubject,
    selectedType,
    selectedNames,
    selectedCoachNames,
    selectedStatus,
    selectedDateRange,
    id,
  ]);

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle>{t("leftNavigation.logs")}</SectionTitle>

            {Auth.isCampaignCoord && (
              <Tabs>
                <Tab
                  label={"campaign"}
                  tabName={t("tabs.campaign")}
                  defaultTab={true}
                />
                <Tab
                  label={"team"}
                  tabName={t("tabs.team")}
                  linkTo={"/logs/team"}
                />
              </Tabs>
            )}

            {id && (
              <div className={`${styles.status} ${styles.tag}`}>
                {getQueryVariable("name")}
                <CancelIcon
                  onClick={() => {
                    setId("");
                    history.push("/logs/campaign");
                  }}
                />
              </div>
            )}
            <LogsFilterBar
              storageKey={STORAGE_KEY}
              onChange={setFilterValues}
              dateRange
              type
              subject={{
                groupBy: option =>
                  option.subject + " - " + option.functional_unit,
              }}
              coach
              coachee
              status
            />

            <LogsTable
              getDataFrom={"/api/getCampaignTeamSessionLogs"}
              uid={uid}
              coacheeId={id}
              coachId={CoachesFilterBy}
              campaignId={selectedCampaign}
              coachName={true}
              searchKey={searchKey}
              tableHeader={campaignTableHeader}
              customParam={`?uid=${uid}&user_role=${userRole}${id ? `&coachee=${id}` : filterParam
                }&campaign_id=${selectedCampaign}`}
              filterObj={filterObj}
            />
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
